import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable, action } from 'mobx'

import Button from '../../../../UniformComponents/Button'
import Panel from '../../../../UniformComponents/Panel'
import DataTable from '../../../DataTable'
import Typography from '../../../../UniformComponents/Typography'
import StatusEditModal from './StatusEditModal'
import ConfirmationModal from '../../../../UniformComponents/ConfirmationModal'

@observer
class NewServiceStatusHeader extends Component {
    @observable isEditModalOpen = false

    @observable isDeleteModalOpen = false

    @observable messageIdToBeEdited

    messageIdToBeDeleted

    constructor(props) {
        super(props)
        makeObservable(this)
        this.intranetStore = props.intranetStore
        this.columns = this.buildTableColumns()
    }

    async componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'serviceStatus',
                url: '/intranet/serviceStatus',
                title: 'Service Status',
            },
        ]
        await this.intranetStore.getAllServiceStatus()
    }

    buildTableColumns = () => [
        {
            key: 'id',
            name: 'ID',
            headerClass: 'center',
            cellClass: 'center',
        },
        {
            key: 'style',
            name: 'Style',
            headerClass: 'center',
            cellClass: 'center',
        },
        {
            key: 'status',
            name: 'Status',
            headerClass: 'status-column',
            cellClass: 'status-cell',
        },
        {
            key: 'enabled',
            name: 'Enabled',
            headerClass: 'center',
            cellClass: 'center',
            dataTransform: (value) => (value ? '🟢' : '🔴'),
        },
        {
            key: 'collapsible',
            name: 'Collapsible',
            headerClass: 'collapsible-column center',
            cellClass: 'center',
            dataTransform: (value) => (value ? 'Yes' : 'No'),
        },
        {
            key: 'textColor',
            name: 'Text colour',
            headerClass: 'text-color-column center',
            cellClass: 'center',
            dataTransform: (value) => (
                <div style={{
                    backgroundColor: value,
                    width: '70px',
                    height: '30px',
                    border: '1px solid #ccc',
                    marginInline: 'auto',
                }}
                />
            ),
        },
        {
            key: 'bgColor',
            name: 'Header colour',
            headerClass: 'bg-color-column center',
            cellClass: 'center',
            dataTransform: (value) => (
                <div style={{
                    backgroundColor: value,
                    width: '70px',
                    height: '30px',
                    border: '1px solid #ccc',
                    marginInline: 'auto',
                }}
                />
            ),
        },
        {
            key: 'edit',
            name: 'Edit',
            headerClass: 'edit-column center',
            cellClass: 'center',
            dataTransform: (value, row) => (
                <i
                    className="fa-regular fa-edit"
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => this.openEditMessageModal(e, row.id)}
                />
            ),
        },
        {
            key: 'delete',
            name: 'Delete',
            headerClass: 'delete-column center',
            cellClass: 'center',
            dataTransform: (value, row) => (
                <i
                    className="fa-regular fa-trash"
                    style={{ cursor: 'pointer', color: '#C2001C' }}
                    onClick={(e) => this.openDeleteModal(e, row.id)}
                />
            ),
        },
    ]

    @action
    openEditMessageModal = (e, id) => {
        e.stopPropagation()
        if (id) this.messageIdToBeEdited = id
        else this.messageIdToBeEdited = null
        this.isEditModalOpen = true
    }

    @action
    closeEditMessageModal = () => {
        this.isEditModalOpen = false
        this.messageIdToBeEdited = null
    }

    @action
    deleteServiceStatusMsg = (id) => {
        if (!id) return
        this.intranetStore.deleteServiceStatus(id)
        this.closeDeleteModal()
    }

    @action
    openDeleteModal = (e, id) => {
        e.stopPropagation()
        this.messageIdToBeDeleted = id
        this.isDeleteModalOpen = true
    }

    @action
    closeDeleteModal = () => {
        this.isDeleteModalOpen = false
        this.messageIdToBeDeleted = null
    }

    render() {
        const { intranetStore } = this.props
        const { allServiceStatusMessages } = intranetStore

        return (
            <div id="ssm">
                <Panel cssClass="ssm-main-panel">
                    <div className="panel-header">
                        <Typography type="h2">
                            Service Status Message
                        </Typography>
                        <Button
                            cssClass="add-button regular"
                            variant="primary"
                            label="Add new"
                            icon="fa-light fa-circle-plus"
                            onClick={(e) => this.openEditMessageModal(e)}
                        />
                    </div>

                    <DataTable
                        dataSet={allServiceStatusMessages || []}
                        columns={this.columns}
                        rowId="id"
                        inMemory
                        cssClass="service-status-table"
                    />
                </Panel>

                {this.isEditModalOpen && (
                    <StatusEditModal
                        msgId={this.messageIdToBeEdited}
                        onClose={this.closeEditMessageModal}
                        intranetStore={intranetStore}
                    />
                )}

                <ConfirmationModal
                    show={this.isDeleteModalOpen}
                    title="Are you sure?"
                    description={`You will delete status message 
                        <strong>${allServiceStatusMessages.find((msg) => msg.id === this.messageIdToBeDeleted)?.status}.</strong>
                        This action cannot be undone.`}
                    onClose={this.closeDeleteModal}
                    onTrue={() => this.deleteServiceStatusMsg(this.messageIdToBeDeleted)}
                    onFalse={this.closeDeleteModal}
                />
            </div>
        )
    }
}
export default NewServiceStatusHeader
